import React, { useState, useEffect } from "react";

const CommunityAvatar = ({ community, isRound = true }) => {
    const colors = [
        "bg-blue-200 text-yellow-700",
        "bg-green-200 text-green-700",
        "bg-yellow-200 text-yellow-700",
        "bg-blue-200 text-yellow-700",
        "bg-red-200  text-red-700", 
        "bg-purple-200 text-purple-700"
    ];
    const getColorByName = (name) => {
        if (!name || name.length === 0) return colors[0];
        const firstChar = name[0].toUpperCase();
        const charCode = firstChar.charCodeAt(0);
        // Use modulo to stay within the colors array
        const colorIndex = charCode % colors.length;
        return colors[colorIndex];
    };
    let letter = community.title ? community.title.trim() : " ";
    letter = letter[0];
    let iconUrl = community?.icon ? community.icon : "";
    const color = getColorByName(community.title || "");
    return (
        <>
            {iconUrl.length == 0 && 
                <div className={`${color} flex items-center justify-center h-full w-full ${isRound ? "rounded-full" : "rounded-sm"} uppercase font-bold text-lg font-sans`}> 
                    {letter}
                </div>
            }
            {iconUrl.length > 0 && 
                <img
                    className={`inline-block  w-[30px] h-[30px] max-w-[30px] max-h-[30px] ${isRound ? "rounded-full" : "rounded-sm"} `}
                    src={iconUrl}
                    alt=""
                />
            }
        </>
    );
};

export default CommunityAvatar;